
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic09On as ObiHydraulic09OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-09-on.js';
 
 
 

 
 export const ObiHydraulic09On = createComponent({
   react: React,
   tagName: 'obi-hydraulic-09-on',
   elementClass: ObiHydraulic09OnElement,
   events: {
     
   }
  });
 
 